import { Store } from '../../typings';

const isSectionTouched = (store: Store, sectionId: string): boolean => {
  return store.controls.touchedSections.indexOf(sectionId) >= 0;
};

export default isSectionTouched;
